<template>
	<div>
		<div style="font-size:20px;float:left;margin:-35px 0 0 40px;font-weight:600">
			<img src="../../../assets/icon/返回.png" style="vertical-align: middle;margin-top:-2px" @click="close" />
			录入应收账款
		</div>
		<div style="background-color:white;margin:75px 40px 0 40px">
			<div style="padding:30px">
				<div style="background-color:#fdfdfd;padding:30px 50px;border:1px solid #f7f7f7">
					<div>
						<img src="../../../assets/icon/录入应收账款.png" style="vertical-align: middle;margin-top:-3px" />
						<span style="color:#006E4B;font-size:18px;font-weight:600">应收账款信息</span>
					</div>
					<div style="display:flex;margin-top:20px">
						<div class="text">
							<span>组织架构：</span><span>{{$globals.group_name}}/{{editList.organize_name}}</span>
						</div>
						<div class="text">
							<span>系列：</span><span>{{editList.series}}</span>
						</div>
						<div class="text">
							<span>业务板块：</span><span>{{editList.industry_andInnovation}}</span>
						</div>
						<div class="text">
							<span>项目名称：</span><span>{{editList.project_name}}</span>
						</div>
					</div>
					<div style="display:flex;margin-top:20px">
						<div class="text">
							<span>甲方开票名头：</span>
							<span>{{editList.party_title}}</span>
						</div>
						<div class="text">
							<span>我方开票名头：</span><span>{{editList.partner_abbreviation}}</span>
						</div>
						<div class="text">
							<span>已开发票金额：</span><span>{{editList.invoiced_amount}}</span>
						</div>
						<div class="text">
							<span>未开发票金额：</span><span>{{editList.not_invoiced_amount}}</span>
						</div>
					</div>
					<div style="display:flex;margin-top:20px">
						<div class="text">
							<span>应收款合计：</span>
							<span>{{editList.account_receivable_total}}</span>
						</div>
					</div>
				</div>
			</div>
			<div style="margin:10px 50px">
				<span style="margin-right:10px;margin-left:10px">回款日期</span>
				<el-date-picker style="width:25%" v-model="condition.start_date" type="daterange"
					range-separator="至" start-placeholder="开始日期" format="yyyy-MM-dd" end-placeholder="结束日期"
					value-format="yyyy-MM-dd">
				</el-date-picker>
				<el-button style="width:85px;height:41px" type="goon" @click="Find">查询</el-button>
				<!-- <el-button style="width:135px;height:41px" type="goon" @click="Plan">回款计划登记</el-button> -->
			</div>
			<div style="margin:3% 2% 0 2%">
				<el-table ref="multipleTable" :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
					:data="tableData" tooltip-effect="dark" style="width: 100%" height="350"
					@selection-change="handleSelectionChange">
					<!-- <el-table-column type="selection" width="55"> </el-table-column> -->
					<el-table-column label="序号" width="50">
						<template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
					</el-table-column>
					<el-table-column prop="period_service" label="服务期" align="center">
					</el-table-column>
					<el-table-column prop="invoice_no" label="发票号" align="center">
					</el-table-column>
					<el-table-column prop="amount_of_money" label="发票金额" align="center">
					</el-table-column>
					<el-table-column prop="receivable_amount" label="应收金额" align="center">
					</el-table-column>
					<el-table-column prop="collection_time" label="回款时间" align="center">
					</el-table-column>
					<el-table-column prop="collection_amount" label="回款金额" align="center">
					</el-table-column>
					<!-- <el-table-column prop="not_invoiced_amount" label="未开票金额" align="center">
					</el-table-column> -->
					<el-table-column prop="invoicing_date" label="开票日期" align="center">
					</el-table-column>
					<el-table-column prop="remarks" label="备注" align="center">
					</el-table-column>
					<el-table-column label="操作" align="center" width="100">
						<template slot-scope="scope">
							<img src="../../../assets/icon/修改.png" @click="Revise(scope.row)" />
						</template>
					</el-table-column>
				</el-table>
				<!-- 分页 -->
				<el-row style=" margin-left: 500px;margin-top: -20px;">
					<el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
						layout=" prev, pager, next, jumper" :total="total">
					</el-pagination>
				</el-row>
			</div>
			<el-dialog title="修改" :visible.sync="showPlan" width="30%" center="true" :close-on-click-modal="false">
				<div>
					<el-form label-position="right" label-width="120px" :model="formLabelAlign">
						<el-form-item label="回款时间">
							<el-date-picker style="width: 100%;" v-model="plan.collection_time" type="date"
								value-format="yyyy-MM-dd" placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
						<el-form-item label="回款金额">
							<el-input v-model="plan.collection_amount" placeholder="请输入回款金额"></el-input>
						</el-form-item>
						<el-form-item label="备注">
							<el-input v-model="plan.remarks" placeholder="请输入备注"></el-input>
						</el-form-item>
						<div style="text-align:center">
							<el-button type="goon" @click="PlanSave()">保存</el-button>
						</div>
						</el-button>
					</el-form>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	export default {
		props: ["editList"],
		data() {
			return {
				ids: [],
				total: 0,
				input: '',
				showPlan: false,
				//条件
				condition: {
					page_num: 1,
					page_size: 10,
					id: '',
					start_date: '',
					end_date: '',
					project_id: '',
				},
				plan: {
					id: '',
					collection_time: '',
					collection_amount: '',
					remarks: '',
				},
				name: this.$globals.user.name,
				date: this.getNowTime(),
				multipleSelection: [],
				input: '',
				tableData: [],

			};
		},

		mounted() {
			this.Find();
		},
		methods: {
			getNowTime() {
				var now = new Date();
				var year = now.getFullYear(); //得到年份
				var month = now.getMonth(); //得到月份
				var date = now.getDate(); //得到日期
				month = month + 1;
				month = month.toString().padStart(2, "0");
				date = date.toString().padStart(2, "0");
				var defaultDate = `${year}-${month}-${date}`;
				return defaultDate;
			},
			// 全选
			handleSelectionChange(e) {
				this.ids = [];
				e.forEach((item) => {
					this.ids.push(item.id);
				});
			},
			//分页
			handleCurrentChange(val) {
				this.condition.page_num = val;
				this.Find();
			},
			//查询
			async Find() {
				var record = {
					page_num: this.condition.page_num,
					page_size: this.condition.page_size,
					id: this.condition.id,
					start_date: this.condition.start_date != null && this.condition.start_date != '' ?
						this.condition.start_date[0] : '',
					end_date: this.condition.start_date != null && this.condition.start_date != '' ?
						this.condition.start_date[1] : '',
					project_id:this.editList.project_id,
				};
				var data = await this.$globals.AxiosPost('accountsReceivable/getRegisterList', record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.tableData = data.list;
						this.total = data.total;
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			Revise(e) {
				this.plan = e;
				this.showPlan = true;
			},
			async PlanSave() {
				var data = await this.$globals.AxiosPost('accountsReceivable/updateRegister', this.plan);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.showPlan = false;
						this.$message.success(data);
						this.plan = {};
						this.Find()
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			handlePhotoSuccess(res, file) {
				this.register.collection_voucher = res.data.fileUrl;
			},
			close() {
				this.$emit('close')
			},

		},
		created() {

		},
	};
</script>

<style>
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 100%;
		height: 300px;
		display: block;
	}
</style>
<style scoped>
	.el-aside {
		height: 700px;
		background-color: #fbfbfb;
	}

	.text {
		width: 25%
	}

	.s {
		width: 260px;
		display: block;
		margin: 20px auto;
	}

	.bor {
		font-size: 20px;
	}

	.add {
		width: 90px;
		height: 35px;
		border-radius: 5px;
		color: #fff;
		background-color: #00724e;
	}

	.add2 {
		width: 90px;
		height: 35px;
		border-radius: 5px;
		color: #00724e;
		background-color: #fff;
		border: 1px solid #00724e;
	}

	.el-table {
		width: 850px;
		margin-top: 40px;
	}

	.el-pagination {
		width: 500px;
		text-align: center;
		margin-top: 30px;
	}

	.prev {
		width: 60px;
		height: 30px;
		position: absolute;
		top: 2px;
		left: 390px;
		color: #9094a0;
		background-color: #edf0f5;
		border: 0;
	}

	.ne {
		width: 60px;
		height: 30px;
		position: absolute;
		top: 2px;
		left: 460px;
		color: #9094a0;
		background-color: #edf0f5;
		border: 0;
	}

	.c {
		position: absolute;
		top: 1px;
		left: 560px;
	}

	.small {
		width: 50px;
		height: 20px;
	}

	.btn {
		width: 60px;
		height: 30px;
		position: absolute;
		background-color: #00724e;
		top: 5px;
		left: 680px;
		color: #fff;
		border-radius: 5px;
	}

	.input {
		width: 200px;
	}

	.el-dropdown {
		vertical-align: top;
	}

	.el-dropdown+.el-dropdown {
		margin-left: 15px;
	}

	.el-icon-arrow-down {
		font-size: 12px;
	}

	.rz {
		margin-top: 20px;
	}

	.el-date-editor.el-input,
	.el-date-editor.el-input__inner {
		width: 150px;
	}

	.el-dropdown /deep/ .el-button-group .el-button {
		width: 90px;
	}

	.el-pagination.is-background /deep/ .el-pager li:not(.disabled).active {
		background-color: #00724e;
	}

	.el-table /deep/ thead {
		color: #000;
		font-weight: 700;
		background-color: #f0f0f0;
	}

	.bm {
		position: relative;
		height: 100px;
	}

	.el-button {
		background-color: #00724e;
		color: #fff;
		width: 100px;
	}

	.Time {
		margin-left: 80px;
	}

	.time {
		margin-bottom: 20px;
	}

	.money {
		margin-bottom: 50px;
	}

	.el-button--qian {
		color: #fff;
		background-color: #006e4b;
		border-color: #006e4b;
		font-size: 13px;
		height: 40px;
		width: 80px;
	}

	.el-button--qian:focus,
	.el-button--qian:hover {
		background: #006e4b;
		border-color: #05573d;
		color: #fff;
	}
</style>



// WEBPACK FOOTER //
// edit.vue?e43d6606